import React, { createContext, useEffect, useState } from 'react'
import Button1 from '../../components/form/Button1'
import { useSnackbar } from 'notistack'
import Icon from '../../components/HOC/Icon';
import CustomTable from '../../components/Table/CustomTable';
import CustomMenu from '../../components/utils/CustomMenu';
import { MenuItem, Tab, Tabs } from '@mui/material';
import { Menu } from './OrdersData';
import Modal1 from '../../components/DIsplay/Modal/Modal1';
import issueTicketManually from '../../controllers/booking/issueTicketManually';
import getTransactions from '../../controllers/booking/Transactions.js/getTransactions';
import { formatMoney } from '../../features/utils/formatMoney';
import approveCashPayment from '../../controllers/booking/Transactions.js/approveCashPayment';
import declineCashPayment from '../../controllers/booking/Transactions.js/declineCashPayment';
import PayoutTable from '../../components/Settings/Wallet/PayoutTable';
import moment from 'moment';
import PayoutLederTable from '../../components/Settings/Wallet/PayoutLederTable';
import useAccount from '../../hooks/useAccount';
import Unauthorized from '../../components/DIsplay/Unauthorized';

const ActionContext = createContext();

export default function Transactions({loadAll,data,close,callback}) {
    const {enqueueSnackbar} = useSnackbar();
    const [loadTransactions,setLoadTransactions] = useState(true)
    const [transactions,setTransactions] = useState([]);

    const [openApprove,setOpenApprove] = useState(false);
    const [openDecline,setOpenDecline] = useState(false);

    const {checkPermission} = useAccount();


    const [paginationModel, setPaginationModel] = React.useState({
        page: 0,
        pageSize: 20,
        rowCount: 0,
    });

    const [tab,setTab] = useState(0);

    const [searchValue,setSearchValue] = useState('');

    useEffect(() => {
        if(data || loadAll)
            listQueues()
        //eslint-disable-next-line
    },[data,paginationModel?.page,searchValue,tab])

    async function listQueues() {
        setLoadTransactions(true);

        const query = {
            limit: paginationModel?.pageSize,
            offset: paginationModel?.page*paginationModel?.pageSize,
        }
        if(searchValue) {
            query.searchBy = 'reason,paymentMode,status,account.firstName,account.lastName,account.email,account.phone';
            query.keyword = searchValue;
          }
      
        
        const res = await getTransactions(new URLSearchParams(query)?.toString());
        // const res = await getQueueTicket(data?._id);
        setLoadTransactions(false);
        if(res.return) {
            setTransactions((res.data?.data || res?.data)?.map(obj => ({...obj,id: obj._id,
                agent: `${obj?.account?.firstName} ${obj?.account?.middleName || ''} ${obj?.account?.lastName || ''}`
            })))
            setPaginationModel({...paginationModel,rowCount: res?.data?.meta?.total})
            // setTransactions(res?.data?.data?.map(obj => ({...obj,
            //     id: obj._id,
            //     pnr: obj?.flightBooking?.pnr,
            //     provider: {
            //         supplier: getSupplierName(obj?.flightBooking?.supplier),
            //         airline: obj?.flightBooking?.flights?.at(0).airlineName,
            //     }
            // })))
        }
    }
    
    async function handlePaymentApprove(transactionId) {
        const reqBody = {
            transactionId
        }
        setOpenApprove({...openApprove,loading: true})
        const res = await approveCashPayment(reqBody);
        setOpenApprove({...openApprove,loading: false})
        if(res.return) {
            enqueueSnackbar('Payment Confirmed.',{variant: 'success'})
            setOpenApprove(false)
            callback && callback()
            listQueues();
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }

    async function handlePaymentDecline(transactionId) {
        const reqBody = {
            transactionId
        }
        setOpenDecline({...openDecline,loading: true})
        const res = await declineCashPayment(reqBody);
        setOpenDecline({...openDecline,loading: false})
        if(res.return) {
            enqueueSnackbar('Payment Declined.',{variant: 'success'})
            setOpenDecline(false)
            callback && callback()
            listQueues();
        } else enqueueSnackbar(res.msg,{variant: 'error'})
    }

    const columns = [
        {field: 'createdAt', headerName: 'Date',flex: 1,
            renderCell: (params) => (
                <div>
                    {moment(params.value)?.format('YYYY-MM-DD HH:mm')}
                </div>
            )
        },
        {field: 'agent', headerName: 'Agent'},
        {field: 'reason', headerName: 'Reason',flex: 1},
        {field: 'description', headerName: 'Description'},
        {field: 'paymentMode', headerName: 'Payment Mode'},
        {field: 'amount', headerName: 'Amount',
            renderCell: (params) => (
                <span>{formatMoney(params.value)}</span>
            )
        },
        {field: 'status', headerName: 'Status',
            renderCell: (params) => (
                <StatusCol params={params} />
            )
        },
    ]
    
    const tabs = ["Transactions",'Payout Requests'];
    if(checkPermission('read:balance-ledger'))
        tabs.push('Payout Ledger')
    
  return (
    <div className='card py-10 p-0 flex flex-col gap-4 justify-center'>
        <Tabs value={tab} onChange={(_,val) => setTab(val)}>
            {tabs?.map((obj,i) => ( // 'Payout Leder'
                <Tab label={<b>{obj}</b>} key={i} />
            ))}
        </Tabs>

        {
            tab === 0 ?
                !checkPermission('read:transactions') ? <Unauthorized /> :
                    <ActionContext.Provider value={{
                        approvePayment: setOpenApprove,
                        declinePayment: setOpenDecline,
                    }}>
                        <CustomTable loading={loadTransactions} rows={transactions} columns={columns} 
                            searchProps={{
                                searchable: true,
                                search: setSearchValue,
                            }}                
                            rowCount={paginationModel?.rowCount}
                            paginationMode="server"
                            paginationModel={paginationModel}
                            onPaginationModelChange={setPaginationModel}
                        
                        />
                    </ActionContext.Provider>
            : tab === 1 ?
                <PayoutTable />
            :
                <PayoutLederTable />
              
        }

        <Modal1 open={openApprove} setOpen={setOpenApprove}>
            <div className='card p-10 flex flex-col  gap-4 max-w-[400px]'>
                <h5>Do you approve payment has been made by cash?</h5>
                <div className='flex justify-end items-center gap-4'>
                    <Button1 variant='outlined' className='btn-outlined flex-1' onClick={() => setOpenApprove(false)}>No, Cancel</Button1>
                    <div>
                        <Button1 onClick={() => handlePaymentApprove(openApprove)} loading={openApprove?.loading}>Yes, I Approve Payment</Button1>
                    </div>
                </div>
            </div>
        </Modal1>
        <Modal1 open={openDecline} setOpen={setOpenDecline}>
            <div className='card p-10 flex flex-col  gap-4 max-w-[400px]'>
                <h5>Do you confirm payment has not been made?</h5>
                <div className='flex justify-end items-center gap-4'>
                    <Button1 variant='outlined' className='btn-outlined flex-1' onClick={() => setOpenDecline(false)}>No, Cancel</Button1>
                    <div>
                        <Button1 onClick={() => handlePaymentDecline(openDecline)} loading={openDecline?.loading}>Yes, Decline Payment</Button1>
                    </div>
                </div>
            </div>
        </Modal1>
    </div>
  )
}


function StatusCol({params}) {
    const [loadings] = useState({approve: false})

    // async function waiter(ev,callback) {
    //     ev?.preventDefault();
    //     ev?.stopPropagation();
        
    //     setLoadings(({...loadings,approve: true}))
    //     await callback(params?.row?._id)
    //     // await new Promise((resolve) => setTimeout(() => resolve(),2000))
    //     setLoadings(({...loadings,approve: false}))
    // }
    
    const MenuContainer = ({children,loader,value,...restProps}) => (
        <Menu {...restProps}
         value={value}
         label={children}
         render={(val) => (
            <div>
                {loadings[loader] ? <div className='load mr-2 border-theme1'></div> :null}
                {val}
            </div>
         )}
        />
    )

    return (
        <div className='flex gap-2 items-center w-full'>
            <div className='flex-1'>
                {params.value}
            </div>
            <ActionContext.Consumer>
                {
                    (value) => {
                        const {approvePayment,declinePayment} = value || {}
                        return (
                            <CustomMenu 
                                element={
                                <label className="block p-2 px-4 cursor-pointer">
                                    <Icon icon={"pepicons-pop:dots-y"} />
                                </label>
                                }
                            >
                                <div className='menuItem'>
                                    {params?.row?.reason === 'IssueTicket' &&
                                     params?.row?.paymentMode === 'Cash' ? 
                                        <div>
                                            <MenuContainer loader={'approve'}
                                                showFor={['Pending']}
                                                onClick={() => approvePayment(params?.row?._id)} value={params.value} >Approve Payment</MenuContainer>

                                            <MenuContainer loader={'decline'}
                                                showFor={['Pending']}
                                                onClick={() => declinePayment(params?.row?._id)} value={params.value} >Decline Payment</MenuContainer>
                                        </div>
                                    :null}
                                    <MenuItem></MenuItem>
                                </div>
                            </CustomMenu>
                        )
                    }
                }
            </ActionContext.Consumer>
        </div>
    )
}